/**
 * The class a dashboard figure wears. A zero is a fact, not a headline: on the
 * Outbound card half the tiles read 0 at the same 30px weight as 217, so the
 * page shouted about nothing (docs/design-rule.md, Drop 36). Zeros drop to
 * muted ink; everything else keeps the figure style.
 */
export function kpiValueClass(value: number): string {
  return value === 0 ? 'tracker-kpi-value tracker-kpi-value--zero' : 'tracker-kpi-value';
}
